import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../../utils/format';
import type { CoApplicantHousingData } from '../../../../FormData.se.types';
import { housingOptions } from '../../../../config/globals';
import { gridColumns } from '../../../../config/layouts/grid';
import {
  rentCostMonthlyFieldOptions,
  requiredField,
} from '../../../shared-config';

export const CoApplicantHousing = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const askHousingType =
    watch('LoanApplication/CoApplicantIsCohabitant') === 'No';

  const housingType = watch('LoanApplication/CoApplicantHousingType');

  return (
    // TODO: Fix styles
    <Grid columns={gridColumns} style={{ alignItems: 'flex-end' }}>
      {askHousingType && (
        <DropdownFieldUI<CoApplicantHousingData>
          name="LoanApplication/CoApplicantHousingType"
          label={t('HousingType.label', { context: 'coapp' })}
          data-testid="housing-dropdown"
          options={housingOptions}
          registerOptions={requiredField}
        />
      )}

      {housingType && (
        <NumberFieldUI<CoApplicantHousingData>
          name="LoanApplication/CoApplicantRentCostMonthly"
          label={t('RentCostMonthly.label', {
            context: `${housingType}_coapp`,
          })}
          data-testid="rent-cost-input"
          suffix={t('suffix.currency')}
          format={formatSpacedNumber}
          {...rentCostMonthlyFieldOptions}
        />
      )}
    </Grid>
  );
};
